module.exports = __webpack_public_path__ + "img/music-promotion-copywriting.77becfab.jpg";